<template>
    <div v-if="status == 'successShop'">
        <form @submit.prevent="updateSettings" id="settings_form">
            <div id="message_div"></div>
            <kt-row id="first_row">
                <kt-col lg="12" md="12" sm="12">
                    <kt-form-group>
                        <kt-form-label for="collective_status">
                            {{ $t('label.collective_status') }}
                        </kt-form-label>
                        <div class="custom-control custom-checkbox" id="collective_status-div">
                            <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="collective_status"
                                    name="collective_status"
                                    @change="changeLabel"
                                    v-model="form_data.status"
                            >
                            <label class="custom-control-label" id="collective_status_label" for="collective_status">

                            </label>
                        </div>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row v-if="form_data.status">
                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-form-group>
                                <kt-form-label for="priority">
                                    {{ $t('label.priority') }}
                                </kt-form-label>
                                <select
                                        id="priority"
                                        name="priority"
                                        v-model="form_data.priority"
                                        class="form-control"
                                >
                                    <option value="1" :selected="form_data.priority == 1">
                                        {{ $t('label.normal_priority') }}
                                    </option>
                                    <option value="2" :selected="form_data.priority == 2">
                                        {{ $t('label.high_priority') }}
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <div class="custom-control custom-checkbox" id="has_time_limitation-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="has_time_limitation"
                                            name="has_time_limitation"
                                            v-model="form_data.has_time_limitation"
                                    >
                                    <label class="custom-control-label" id="has_time_limitation_label" for="has_time_limitation">
                                        {{ $t('label.has_time_limitation') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12" v-if="form_data.has_time_limitation">
                            <kt-form-group>
                                <kt-form-label for="start_date">
                                    {{ $t('label.start_date') }}
                                </kt-form-label>
                                <datePicker
                                        color="#00c1a4"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        display-format="jDD jMMMM jYYYY - HH:mm:ss"
                                        input-class="form-control"
                                        id="start_date"
                                        name="start_date"
                                        type="datetime"
                                        v-model="form_data.start_date"
                                />
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="4" md="4" xs="12" v-if="form_data.has_time_limitation">
                            <kt-form-group>
                                <kt-form-label for="end_date">
                                    {{ $t('label.end_date') }}
                                </kt-form-label>
                                <datePicker
                                        color="#00c1a4"
                                        format="YYYY-MM-DD HH:mm:ss"
                                        display-format="jDD jMMMM jYYYY - HH:mm:ss"
                                        input-class="form-control"
                                        id="end_date"
                                        name="end_date"
                                        type="datetime"
                                        v-model="form_data.end_date"
                                />
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>

                <kt-col lg="6" md="6" xs="12">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <div class="custom-control custom-checkbox" id="has_transaction_count_limitation-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="has_transaction_count_limitation"
                                            name="has_transaction_count_limitation"
                                            v-model="form_data.has_transaction_count_limitation"
                                    >
                                    <label class="custom-control-label" id="has_count_limitation_label" for="has_transaction_count_limitation">
                                        {{ $t('label.has_transaction_count_limitation') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" v-if="form_data.has_transaction_count_limitation">
                            <kt-form-group>
                                <kt-form-label for="transaction_count_limit">
                                    {{ $t('label.count_limit') }}
                                </kt-form-label>
                                <kt-form-control
                                        dir="ltr"
                                        id="transaction_count_limit"
                                        type="number"
                                        name="transaction_count_limit"
                                        v-model="form_data.transaction_count_limit">
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-row>
                        <kt-col lg="12" md="12" xs="12">
                            <kt-form-group>
                                <div class="custom-control custom-checkbox" id="has_transaction_amount_limitation-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="has_transaction_amount_limitation"
                                            name="has_transaction_amount_limitation"
                                            v-model="form_data.has_transaction_amount_limitation"
                                    >
                                    <label class="custom-control-label" id="has_amount_limitation_label" for="has_transaction_amount_limitation">
                                        {{ $t('label.has_transaction_amount_limitation') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12" v-if="form_data.has_transaction_amount_limitation">
                            <kt-form-group>
                                <kt-form-label for="transaction_amount_limit">
                                    {{ $t('label.amount_limit') }}
                                </kt-form-label>
                                <div class="kt-input-icon kt-input-icon--right">
                                    <kt-form-control
                                            dir="ltr"
                                            id="transaction_amount_limit"
                                            name="transaction_amount_limit"
                                            v-model="form_data.transaction_amount_limit">
                                    </kt-form-control>
                                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                            <span>{{ $t('currency.rial') }}</span>
                        </span>
                                </div>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_settings_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </div>
</template>

<script>
import $ from "jquery"
import { i18n } from '@/plugins/i18n'
import {mapGetters} from "vuex"
import { KTApp } from '@/plugins/core/app'
import { collectiveService } from '@/common/api.service'

export default {
    props: {
        shop_type: {
            required: true
        }
    },
    computed: {
        ...mapGetters('collective', [
            'form_data',
            'status'
        ])
    },
    mounted() {
        if (this.shop_type == '-1') {
            this.$store.dispatch('collective/find', this.$route.params.hashid)
                .finally(() => {
                    this.changeLabel()
                })
        } else {
            let params = {
                hashid: this.$route.params.hashid,
                shop_type: this.shop_type
            }
            this.$store.dispatch('collective/findByShopId', params)
                .finally(() => {
                    this.changeLabel()
                })
        }
    },
    methods: {
        changeLabel(){

            let label = $('#collective_status_label')
            let checkbox = $('#collective_status')

            if (checkbox.is(':checked')) {
                label.html(i18n.t('label.active'))
            } else {
                label.html(i18n.t('label.inactive'))
            }
        },
        updateSettings(){
            let btn = $('#change_settings_btn')
            let form = $('#message_div')
            KTApp.progress(btn)

            collectiveService.update(this.form_data.gateway.id, this.form_data).then(response => {
                this.$store.dispatch('badgeCounter/countData')
                this.showMsg(form, 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>